// Плеер: сохранённая запись с сервера, а без неё — запасной голос ОС (speech.ts).
// Один общий HTMLAudioElement; перед каждым запуском текущий звук и синтез останавливаются,
// поэтому повторное нажатие не накладывает звук на звук. Замедление — playbackRate
// с сохранением высоты голоса (preservesPitch).

import { speak, stopSpeech } from './speech.ts';

export type Source = { kind: 'file'; key: string } | { kind: 'speech'; text: string } | null;

export interface PlayRequest {
  /** Ключ записи; null — записи нет. */
  key: string | null;
  /** Текст для голоса ОС; не передаётся там, где запасной голос запрещён (аудиокарточка). */
  fallbackText?: string;
  rate?: number;
}

/** Что сыграет кнопка: запись, голос ОС или ничего (тогда кнопка неактивна). */
export function pickSource(req: PlayRequest, canSpeak: boolean): Source {
  if (req.key) return { kind: 'file', key: req.key };
  if (req.fallbackText && canSpeak) return { kind: 'speech', text: req.fallbackText };
  return null;
}

export const audioUrl = (key: string) => `/api/audio/${encodeURIComponent(key)}`;

let el: HTMLAudioElement | null = null;

function player(): HTMLAudioElement {
  if (!el) {
    el = new Audio();
    el.preload = 'auto';
  }
  return el;
}

export function stopAudio(): void {
  if (el) {
    el.pause();
    try { el.currentTime = 0; } catch { /* ещё не загружено */ }
  }
  stopSpeech();
}

/** Играет запись с начала; если файл не загрузился, а запасной текст есть — голос ОС. */
export function play(req: PlayRequest, canSpeak: boolean): void {
  const src = pickSource(req, canSpeak);
  stopAudio();
  if (!src) return;
  if (src.kind === 'speech') {
    speak(src.text);
    return;
  }
  const a = player();
  const url = audioUrl(src.key);
  if (!a.src.endsWith(url)) a.src = url;
  const rate = req.rate ?? 1;
  a.defaultPlaybackRate = rate;
  a.playbackRate = rate;
  a.preservesPitch = true;
  try { a.currentTime = 0; } catch { /* ещё не загружено */ }
  a.play().catch((e) => {
    console.warn('audio', e);
    if (req.fallbackText && canSpeak) speak(req.fallbackText);
  });
}
